module.exports = {
  ttzj: {
    'zh-CN': '天域战记',
	'zh-TW': '天域戰記',
    'en-US': 'Paradise War',
    'th-TH': 'Paradise War'
  },
  mhsy: {
    'zh-CN': '梦幻神域',
	'zh-TW': '夢幻神域',
    'en-US': 'Sword of Fantasy',
    'th-TH': 'Sword of Fantasy'
  },
  bhmtzh: {
    'zh-CN': '巴赫姆特之魂',
	'zh-TW': '巴哈姆特之魂',
    'en-US': 'Dragon Hunter',
    'th-TH': 'Dragon Hunter'
  },
  jws: {
    'zh-CN': '極無雙',
	'zh-TW': '極無雙',
    'en-US': 'Dynasty Legends',
    'th-TH': 'Dynasty Legends'
  },
  luna: {
    'zh-CN': 'lunaM',
	'zh-TW': 'LunaM',
    'en-US': 'lunaM',
    'th-TH': 'lunaM'
  },
  download: {
    'zh-CN': 'Apk下载',
	'zh-TW': 'APK下載',
    'en-US': 'Apk Download',
    'th-TH': 'Apk Download'
  }
};



// WEBPACK FOOTER //
// ./src/lang/games.js